import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Grid,
  Input,
  Text,
  Textarea,
} from "@chakra-ui/react";
import { useContext, useState } from "react";
import { useFormContext } from "react-hook-form";
import PricingAssistantCallRealtime from "./PricingAssistantCallRealtime";
import { AgencyContext } from "../Settings/AgencyProvider/AgencyProvider";
import TagSelect from "../Tags/TagSelect";

const BasicDetails = (props) => {
  const {
    register,
    formState: { errors },
    watch,
  } = useFormContext();
  const { id } = props;
  const [descFocused, setDescFocused] = useState(false);
  const { assistant_type = "simple", llmModel, voiceLanguages } = watch();
  const voice_stt_id = voiceLanguages.length ? voiceLanguages[0].id : null;
  const llm_model_id = llmModel?.id;
  const voice_tts_id = voiceLanguages.length
    ? voiceLanguages[0]?.speaker?.value
    : null;
  const makePricingParams = () => {
    if (assistant_type === "realtime_openai")
      return { llm_model_id, voice_stt_id: null, voice_tts_id: null };
    if (assistant_type === "phone")
      return [voice_stt_id, llm_model_id, voice_tts_id].every(Boolean)
        ? { voice_stt_id, voice_tts_id, llm_model_id }
        : null;
    return null;
  };
  const pricingParams = makePricingParams();

  const agency = useContext(AgencyContext);
  const { myDetails } = agency;

  return (
    <Grid templateColumns={assistant_type === "simple" ? null : "1fr 1fr"}>
      <Grid templateColumns={id ? "1fr 2fr 1fr" : "1fr 2fr"} gap={3} alignItems="start">
        <FormControl isInvalid={errors.name}>
          <FormLabel htmlFor="name"><Text>Name</Text></FormLabel>
          <Input
            placeholder="Name"
            {...register("name", { required: "Name is required" })}
          />
          {errors.name && <FormErrorMessage>{errors.name.message}</FormErrorMessage>}
        </FormControl>
        <FormControl isInvalid={errors.description}>
          <FormLabel htmlFor="description"><Text>Description</Text></FormLabel>
          <Textarea
            placeholder="Not used by the LLM. Please use system prompt field to finetune the model"
            {...register("description", { required: "Description is required" })}
            rows={descFocused ? 4 : 1}
            resize="none"
            overflow="hidden"
            transition="rows 0.2s"
            onFocus={() => setDescFocused(true)}
            onBlur={() => setDescFocused(false)}
          />
          {errors.description && <FormErrorMessage>{errors.description.message}</FormErrorMessage>}
        </FormControl>
        {id && (
          <FormControl isInvalid={errors.tagSelect}>
            <FormLabel htmlFor="tagSelect"><Text>Tags</Text></FormLabel>
            <TagSelect tagSelectHook={props.tagSelectHook} />
          </FormControl>
        )}
      </Grid>
      {pricingParams &&
      ["realtime_openai", "phone"].includes(assistant_type) &&
      !myDetails?.agency_id ? (
        <PricingAssistantCallRealtime {...pricingParams} />
      ) : null}
    </Grid>
  );
};

export default BasicDetails;
